import { mutationOptions } from '@tanstack/react-query';

import { adminUserApi } from './admin-user.api';

export function signOutOptions() {
    return mutationOptions({
        mutationFn: () => adminUserApi.signOut(),
    });
}
